/** @module Fixed vocabularies of an owned copy, shared by the collection, card and review screens. */

export const CONDITIONS = ["MT", "NM", "EX", "GD", "LP", "PL", "PO"] as const;
export const LANGUAGES = ["de", "en", "fr", "it", "es", "pt"] as const;
/** Why a copy left the collection; the server knows exactly these. */
export const ARCHIVE_REASONS = ["sold", "traded", "lost", "gifted"] as const;

export type Condition = (typeof CONDITIONS)[number];
